module.exports = __webpack_public_path__ + "static/media/sg10cr93_v2.f7acfce4.png";